<!--
================================================
Un composant pour créer/modifier un tag

Url d'accès :
http://localhost:8080/fr/samsonite/samsonite-workspace/tags

LIMITATION DU COMPOSANT :

 * Un erreur "vue.runtime.esm.js?2b0e:587 [Vue warn]: Error in nextTick: "TypeError: Cannot read property 'focus' of undefined"" S'affiche parfois elle est liée à focusTagName()." Cependant le focus fonctionne bien. Je laisse comme ça pour le moment. //@todo à conserver pour les tags  ?(copie depuis project)

 * [UX] Lorsque l'on est dans le textarea que l'on fait "entrer" le form est envoyé

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>


  <div class="modal" id="ModalTagManagementComp" v-on:keyup.esc="hideModal()"
       v-bind:class="{ 'is-active': isVisible, 'darkMode':themeToDisplay=='dark' }">
    <!--ajouter la classe is-active sur.modal pour l'afficher-->
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <font-awesome-icon :icon="['fas', 'tag']" class="icon"/>

        <p class="modal-card-title has-text-left">
          <span v-if="mode== 'creation'">{{ $t('CréerUnNouveauTag') }}</span>
          <span v-if="mode== 'edition'">{{ $t('ModifierUnTag') }}</span>

        </p>
        <button v-on:click="hideModal()" id="closeModalTagManagement" class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">


        <!-- v-on:submit.prevent évite un comportement de rechargement de la page (au lieu de soumission du form) @link https://forum.vuejs.org/t/modal-form-submit-always-reloads-page/1279-->
        <form action="" v-on:keyup.enter="validateBeforeSubmit" v-on:submit.prevent>

          <!--------CHAMP NAME----------------------------------->
          <div class="field">
            <label style="" class="label mb-1" for="modalTagManagement_name">{{ $t('Nom') }}</label>
            <input class="input tagName" type="text" v-bind:placeholder="$t('exempleCIR')"

                   ref="tagName"
                   v-model="newTag.name"
                   v-validate="'required|max:80'"
                   data-vv-validate-on="change"
                   name="modalTagManagement_name"
                   id="modalTagManagement_name"
                   v-bind:class="{'is-loading':isSubmiting}"
            >
            <p class="help mt-1 is-danger has-text-left" id="error_modalTagManagement_name">
              {{ errors.first('modalTagManagement_name') }}</p>

            <p v-if="showErrorExistingTag" class="help mt-1 is-danger has-text-left" id="errorTagAlreadyExist">
              {{ $t('unTagIdentiqueExisteDéjà') }}</p>

          </div>

          <!--------CHAMP COLOR----------------------------------->
          <div class="field">
            <label class="label" for="modalTagManagement_color">{{ $t('CouleurDuTag') }}</label>
            <p class="help">{{ $t('PermettraDitentifierVotreTag') }}</p>

            <tag-color-selector-comp
                v-bind:mode="mode"
            ></tag-color-selector-comp>
            <input type="hidden" id="modalTagManagement_color" v-model="newTag.color" name="modalTagManagement_color"
                   v-validate="{required:true}">
            <p class="help is-danger has-text-left" id="error_modalTagManagement_color">
              {{ errors.first('modalTagManagement_color') }}</p>

          </div>

          <!--------CHAMP DESCRIPTION----------------------------------->
          <div class="field mt-6">
            <label style="" class="label mb-1 " for="modalTagManagement_desc">{{ $t('Description') }}
              <span class="is-size-7 ml-1 has-text-weight-normal">({{ $t('optionnel') }})</span></label>
            <textarea class="textarea p-4  tagDesc" type="text"
                      v-bind:placeholder="$t('ExempleLeTagCIRIdentifieLesPointages')"
                      tabindex="0"
                      rows="2"
                      v-model="newTag.description"
                      maxlength="255"
                      data-vv-validate-on="change"
                      name="modalTagManagement_desc"
                      id="modalTagManagement_desc"
                      v-bind:class="{'is-loading':isSubmiting}"
            ></textarea>

            <p class="help is-danger has-text-left" id="error_modalTagManagement_desc">
              {{ errors.first('modalTagManagement_desc') }}</p>

          </div>

          <!--------------------------------------------------------------->
          <div class="columns settingsZone">

            <!--------CHAMP ARCHIVE----------------------------------->
            <div class="column blocArchive" v-if="mode=='edition'">

              <div class="field">
                <label class="label" for="modalTagManagement_archive">{{ $t('archivage') }}</label>
                <input v-on:click="toggleArchive" id="modalTagManagement_archive" type="checkbox"
                       name="modalTagManagement_archive" class="switch is-medium is-rounded"
                       v-model="reversedIsArchivedComputed" checked="checked"
                       v-bind:class="{'isArchived':newTag.isArchived}">
                <label for="modalTagManagement_archive" class="archiveLabel">
                  <!-- à afficher même vide sinon le switch n'est pas visible-->
                  <span v-if="newTag.isArchived" class="indicator">
                                        <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                        {{ $t('TagArchivé') }}
                                    </span>
                  <span v-else class="indicator">
                    <font-awesome-icon class="icon" :icon="['far', 'folder-open']"/>
                                        {{ $t('TagActif') }}
                  </span>

                </label>

                <span class="help">
                  <span v-if="newTag.isArchived">{{ $t('CeTagEstArchivé') }}</span>
                  <span v-else>{{ $t('CeTagEstActif') }}</span>
                </span>

              </div>
            </div>

          </div>


        </form>

      </section>
      <footer class="modal-card-foot">
        <a v-on:click="hideModal()" class="button is-text cancelLink">{{ $t("annuler") }}</a>
        <a v-on:click="validateBeforeSubmit()" v-bind:class="{'is-loading':isSubmiting}" v-bind:disabled="isSubmiting"
           class="button is-primary validBtn " id="submitModalTagManagement">{{ $t("valider") }}</a>
      </footer>

    </div>

  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "../../mixins/SentryMixin.js";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../../mixins/InterceptorMixin.js";
import _ from 'lodash'
import TagColorSelectorComp from "@/components/Tags/TagColorSelectorComp";
import TrackingMixin from "@/mixins/TrackingMixin";

export default {
  name: 'ModalTagManagementComp', //utile dans vue dev tool
  mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TrackingMixin],

  components: {TagColorSelectorComp},

  props: {},
  data: function () {
    return {
      locale: this.$route.params.locale,
      mode: 'creation', // String le mode dans lequel on utilise la modale : 'creation/edition'
      isVisible: false, // bool | la visibilité de la modale
      isSubmiting: false,
      workspaceSlug: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290


      // NOTE : GARDER  newTag SYNCHRO AVEC resetTag() !
      newTag: // L'objet du nouveau tag à créer
          {
            name: null, // String | le nom du tag
            description: null, //String  | description du tag
            isArchived: false, // Bool si true le tag est archivé
            color: null, // String le code hexadécimal de la couleur du tag (ex 90a4ae) @see TagColorSelectorComp.colors
          },
      showErrorExistingTag: false, // bool | indique s'il faut afficher l'etrreur spéciale au cas où un tag identique éxiste déjàa

      // pour les composants où l'user est identifié ///////////////////////
      organizationSlug: this.$route.params.organization
      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      // user: state => state.user
      organization: state => state.organization,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------

    // other computed props :
    reversedIsArchivedComputed: {
      get: function () {
        return !this.newTag.isArchived;
      },
      set: function (newValue) {
        // this.reversedIsArchived = newValue
      }
    }

  },
  // watch: {
  //     // à chaque fois que la prop computed user change, cette fonction s'exécutera
  //     user: function () {
  //     }
  // },


  methods: {

    /**
     * Focus le champ tag name
     * Inspiré de https://stackoverflow.com/questions/52088691/vue-js-put-focus-on-input
     **/
    focusTagName() {
      this.$nextTick(() => {
        this.$refs.tagName.focus()
      });
    },

    /*
    * Affiche la modale
    */
    showModal() {
      this.isVisible = true
      this.focusTagName()
    },

    /*
    * Masque la modale
    */
    hideModal() {
      this.isVisible = false
      this.isSubmiting = false
      this.resetTag()
    },

    /**
     * Définit toute les propriété de l'objet passé à null
     *
     * Cette sert lorsque l'on ferme la modal puis qu'on la ré-ouvre évite que les informations de l'ouverture précédente restent affichées.
     */
    resetTag() {
      this.newTag.createdBy = {firstname: null, name: null}
      this.newTag.name = null
      this.newTag.description = null
      this.newTag.isArchived = false
      // this.newTag.color = null // on garde la couleur car évite un bug qui affiche une erreur couleur vide dans modal Tag management (@link https://gitlab.com/ousmane1/kronocloud/issues/239) // Cette ligne provient de la copie originale du fichier depuis ModalProjectMangementComp
      this.showErrorExistingTag = false
    },

    /*
      Toggle la property isArchived
    */
    toggleArchive() {
      if (this.newTag.isArchived === true) {
        this.newTag.isArchived = false
      } else {
        this.newTag.isArchived = true
      }
    },


    /**
     * Valide le form avant soumission
     **/
    validateBeforeSubmit() {

      let self = this;
      this.$validator.validateAll().then((result) => {
        if (result) { // si la validation. réussie
          switch (self.mode) {
            case  'creation':
              self.sendCreateQuery()
              break;
            case 'edition':
              self.sendEditQuery()
              break;
          }
        } else { // si il y a des erreurs...
          self.$store.commit('UpdateGlobalNotificationComp', {
            'isVisible': true,
            'color': 'is-danger',
            'message': self.$t('leFormulaireContientDesErreurs')
          });
        }

      })
    }


    /**
     * Envoie la requête post de création d'un tag
     * @return {Promise<{} | never>}
     */
    , sendCreateQuery() {

      this.isSubmiting = true;

      let self = this
      return self.$http
          .post(`/organizations/${self.organizationSlug}/workspaces/${self.workspaceSlug}/tags`,
              {
                name: self.newTag.name,
                isArchived: self.newTag.isArchived,
                color: self.newTag.color,
                description: self.newTag.description,
              },
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

            // on envoie un event pour dire au qu'un nouveau tag a été ajouté
            self.$root.$emit('new_tag_added',response.data)

            self.hideModal()

            self.ga4GlobalEventTrack('Tag created' , {})

            self.$mixpanel.track("Tag created", {"tag": response.data.slug, "name": response.data.name});

            return {}
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
              // Si le tag existe déjà dans le workspace
              if (error.response.status === 400 && error.response.data.message == "A tag with same name already exist in workspace.") {
                self.showErrorExistingTag = true;
              } else {
                self.logToSentry(self, error, 'error')
                let errorCode = '0062';
                let msg = " error creating tag"
                self.showGlobalErrorNotif(self, errorCode)
                self.$gtag.exception({'description': 'error ' + errorCode + ' | ' + msg, 'fatal': false})

                self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": msg})
                self.$sentry.captureMessage(`Error ${errorCode} > ${msg} : ${error}`, 'error')
              }

            }
          })
          .then(function () {
            self.isSubmiting = false;
          })
    }

    /**
     * Envoie la requête patch de modification d'un tag
     * @return {Promise<{} | never>}
     */
    , sendEditQuery() {
      this.isSubmiting = true;

      let self = this
      return self.$http
          .patch(`/organizations/${self.organizationSlug}/workspaces/${self.workspaceSlug}/tags/${self.newTag.slug}`,
              {
                name: self.newTag.name,
                isArchived: self.newTag.isArchived,
                description: self.newTag.description,
                color: self.newTag.color
              },
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

            // on envoie un event pour dire au TagListComp de maj les tags
            self.$root.$emit('tag_edited', response.data)

            self.hideModal()

            // tracking mixpanel
            self.$mixpanel.track("Tag edited", {"tag": response.data.slug});
            self.ga4GlobalEventTrack('Tag edited' , {})

            return {}
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
              self.logToSentry(self, error, 'error')
              let errorCode = '0063';
              let msg = " error editing tag"
              self.showGlobalErrorNotif(self, errorCode)
              self.$gtag.exception({'description': 'error ' + errorCode + ' | ' + msg, 'fatal': false})

              self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": msg})
              self.$sentry.captureMessage(`Error ${errorCode} > ${msg} : ${error}`, 'error')
            }
          })
          .then(function () {
            self.isSubmiting = false;
          })
    },

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {
    // this.logToSentry(this, 'push a log to sentry :)', 'info')


    /*
     * Event show_modal_tag_management, déclenche l'affichage de la modale
     * @param mode String (edition/creation)
     * @param tag L'objet tag (dans le cas du mode edition)
     */
    this.$root.$on('show_modal_tag_management', (mode, tag) => {


      this.mode = mode // on définit le mode de la modale

      switch (mode) {
          // mode creation pré-remplissage du nom du tag
        case  'creation': {

          if (tag != null) {
            this.newTag.name = tag.name
          }
          break;
        }
          // mode edition : hydratation de la modal avec le tag à modifier
        case 'edition': {

          // ici on clone l'objet tag (sinon altère le tag dans le TagListComp)
          let clone = _.clone(tag)
          this.newTag = clone

        }
          break;
      }

      this.showModal()
    })

    /*
     * Listener de l'event tag_color_selected du composant TagColorSelectorComp
     * @param color String (code hexa.)
     */
    this.$root.$on('tag_color_selected', (color) => {
      this.newTag.color = color.code
    })

  }
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/

.modal {


  .modal-card-head .icon {
    margin-right: 0.5rem;
    color: $brandFourth;
  }

  .field {
    margin-bottom: 1.5rem;
  }

  .label {
    margin-bottom: 0;
  }

  .help {
    margin-top: 0;
  }

  .settingsZone {
    /*border-bottom: solid 1px #eee;*/
    /*border-top: solid 1px #eee;*/
    /*padding: 0.5rem 0;*/

    label {
      margin-bottom: 0.5rem;
      /*text-transform: capitalize;*/
      .indicator {
        font-size: 1rem;
      }
    }
  }


  .blocArchive {
  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    label {
      .indicator {
        color: $darkLightBlue;
      }
    }

    .textarea {
      background-color: $darkBg4;
      color: $darkTxt !important;
      border-color: $darkFieldBorder;

      &::placeholder {
        color: lighten($darkFieldBorder, 15%) !important;
      }
    }

    $iconColor: #666;


    .estimate.field {
      .icon {
        color: $iconColor;
      }

    }

  }


}
</style>
